'use client'

import { Product } from '@/redux/services/catalogApi'
import classNames from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import { FC, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface ProductItem {
    id: number
    title: string
    image: string
    type: number[]
    animal_type: number[]
    feeding_type: number[]
    animal_age: number[]
    animal_needs: number[]
    subtitle: string
    volume: number
    expiration_date: string
    description: string
    necessary_list: string[]
    composition_id: number[]
    application: string
    application_values: number[]
    gallery: string[]
    videos: number[]
}

interface Tag {
    id: number
    title: string
    value: string
}

type ProductProps = {
    item: Product | any
    bottom?: number
    right?: number
    onClick?: any
    tag?: Tag
    linked?: Boolean
    vacancyCard?: Boolean
    type?: string
    lightTheme?: boolean
}

const CatalogProdCard: FC<ProductProps> = ({
    item,
    tag,
    linked,
    type,
    vacancyCard,
    right,
    bottom,
    onClick,
    lightTheme
}) => {
    const [hoverOn, setHoverOn] = useState(false)
    const { t } = useTranslation()

    const getLink = useMemo(
        () =>
            item && vacancyCard
                ? `/vacancy/${item.translit}`
                : item
                ? `/catalog/${item?.type && item?.type[0].value ? `${item?.type[0].value}/` : 'category/'}${
                      item?.animal_type && item?.animal_type[0] && item?.animal_type[0]?.translit
                          ? `${item?.animal_type[0].translit}/`
                          : 'subcategory/'
                  }${item.translit}`
                : '',
        []
    )

    const lineOnHover: any = useMemo(() => {
        setHoverOn(true)
    }, [])

    const lineOffHover: any = useMemo(() => {
        setHoverOn(false)
    }, [])

    return (
        <>
            {linked == true ? ( //НУЖНО ДЛЯ АДМИНКИ
                <Link href={getLink}>
                    <li
                        onMouseEnter={lineOnHover}
                        onMouseLeave={lineOffHover}
                        className='catalog__product'
                    >
                        <div className='catalog__product-title'>
                            <h3>{item.title}</h3>
                        </div>
                        <Image
                            src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${
                                vacancyCard ? item.preview : item.image
                            }`}
                            width={403}
                            height={346}
                            alt='card-image'
                        />
                        <p className='categories-slider__text'>
                            {hoverOn
                                ? t('moreDetailedTest')
                                : vacancyCard
                                ? item?.region[0]?.title
                                : item?.type
                                ? item?.type[0]?.title
                                : t('moreDetailedTest')}
                        </p>
                    </li>
                </Link>
            ) : (
                <li
                    onMouseEnter={lineOnHover}
                    onMouseLeave={lineOffHover}
                    className='catalog__product'
                    onClick={onClick}
                >
                    <div className={classNames('catalog__product-title', lightTheme ? 'lightColor' : '')}>
                        <h3>{item.title}</h3>
                    </div>
                    <Image
                        src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${item.image || item.preview}`}
                        style={bottom ? { width: 300, height: 300,right, bottom } : {}}
                        width={bottom ? 300 : 403}
                        height={bottom ? 300 : 346}
                        alt='card-image'
                    />
                    <p className='categories-slider__text'>
                        {hoverOn
                            ? t('moreDetailedTest')
                            : item?.type && item?.type[0] && item?.type[0]?.title
                            ? item?.type[0]?.title
                            : vacancyCard
                            ? 'PDF'
                            : ''}
                    </p>
                </li>
            )}
        </>
    )
}

export default CatalogProdCard
